import { Component, Inject } from '@angular/core';
import { Complaint, ComplaintAppointment } from '@icc/b2b/shared';
import { DIALOG_DATA, DialogRef } from '@icc/ui';

@Component({
    selector: 'icc-complaint-appointment-preview',
    templateUrl: './complaint-appointment-preview.component.html',
    styleUrls: ['./complaint-appointment-preview.component.scss'],
})
export class ComplaintAppointmentPreviewComponent {

    constructor(
        private dialogRef: DialogRef,
        @Inject(DIALOG_DATA)
        public data: {
            appointment: ComplaintAppointment;
            document: Complaint;
        },
    ) {}

    close() {
        this.dialogRef.close();
    }
}
